"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("@/libs/axios"));
// 多环境
var baseUrl = process.env.VUE_APP_BASE_API;
var axios = new _axios.default(baseUrl);
var _default = exports.default = axios;